import { defineStore } from "pinia";
import _ from "lodash";
import { BalanceTransferMethod, BalanceTransferState, BalanceTransferStep } from "@/shared/types";

export const initialState: BalanceTransferState = {
  currentStep: BalanceTransferStep.TransferFunds,
  transferMethod: BalanceTransferMethod.None
};

export const useBalanceTransferStore = defineStore("balanceTransfer", {
  state: () => (_.cloneDeep(initialState)),
  getters: {
    currentStepTitle: (state: BalanceTransferState) => {
      switch (state.currentStep) {
        case BalanceTransferStep.TransferFunds:
          return "Transfer funds";
        default:
          return "";
      }
    },
    isTransferFundsStep: (state: BalanceTransferState) => state.currentStep === BalanceTransferStep.TransferFunds
  }
});
